<!-- delete cms member not assigned to any engagements -->
<ng-container *ngIf="(dialogType === 'delete_CMS_no_eng_assigned')">
    <div class="countable-dialog confirmation-dailog">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Delete Team Member</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-16 mt-2 mb-32">
            <p>You are trying to delete a Countable Managed Staff. </p>
            <p class="fw-bold">This member is not yet assigned to any active engagements. </p>
            <p class="text-gray-6">Do you want to delete the team member?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button [mat-dialog-close]="false" mat-stroked-button color="dark" class="button-default">Cancel
            </button>
            <button mat-button [mat-dialog-close]="true" mat-flat-button color="error" class="button-default">Delete
            </button>
        </div>
    </div>
</ng-container>


<!-- step 1 delete cms member without re-assigned to any engagements -->
<ng-container *ngIf="(dialogType === 'delete_CMS_without_reassigned' && !selectedData) ">
    <div class="countable-dialog w-400">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Delete CMS Member</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
            <p class="px-3">
                We notice that you currently have active engagements within your Flex Plan that involve this Countable
                Managed
                Staff
            </p>
            <p class="text-error fw-semibold px-3">Note: Removing the Countable Managed Staff (CMS) will affect active
                engagement
            </p>
            <p class="text-gray-6 px-3">Would you like to reassign the staff or proceed with the deletion?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button (click)="deleteCmsReassigned('reassign')" mat-button mat-stroked-button color="dark"
                class="button-default">Reassign
            </button>
            <button mat-button mat-flat-button color="error" (click)="selectedData = 'delete_CMS_without_reassigned'"
                class="button-default">Delete
            </button>
        </div>
    </div>
</ng-container>

<!-- step 2 delete cms member without re-assigned to any engagements -->
<ng-container *ngIf="(dialogType === 'delete_CMS_without_reassigned' && selectedData) ">
    <div class="countable-dialog w-400">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Delete CMS Member</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
            <p class="text-error fw-semibold">Note: This is an irreversible action.</p>
            <p>If you still wish to proceed, please enter 'Delete' below</p>

            <mat-form-field floatLabel="always" class="fixed-label label-none">
                <input [formControl]="deleteCmsMember" matInput type="text" placeholder="Delete">
            </mat-form-field>

        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button [mat-dialog-close]="false" mat-button mat-stroked-button color="dark" class="button-default">Cancel
            </button>
            <button [mat-dialog-close]="true" mat-button mat-flat-button color="error"
                [disabled]="!(deleteCmsMember?.value && deleteCmsMember.value.trim().length && deleteCmsMember.value.toLowerCase() === 'delete')"
                class="button-default">Confirm
            </button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="(dialogType === 'delete_CMS_one') ">
    <div class="countable-dialog confirmation-dailog">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Delete Team Member</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
            <p>
                We notice that the there is only one team member assigned to this engagement
            </p>
            <p class="text-error fw-semibold">Please be aware that you must remove the team member from the engagement
                prior
                to deleting them</p>
            <p class="text-gray-6">Do you want to proceed to unassign the team member?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button [mat-dialog-close]="false" mat-stroked-button color="dark" class="button-default">Cancel
            </button>
            <button mat-button (click)="deleteCmsReassigned('reassign')" mat-flat-button color="error"
                class="button-default">Reassign
            </button>
        </div>
    </div>
</ng-container>


<ng-container *ngIf="(dialogType === 'delete_eng_CMS') ">
    <div class="countable-dialog confirmation-dailog">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Delete engagement<br> with CMS Staff</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-16 mt-2 mb-32">
            <p>
                We notice that the engagement you want to delete involves CMS staff
            </p>
            <p class="text-error fw-semibold">Note: You are already billed for this engagement and no refunds will be
                provided
            </p>
            <p class="text-gray-6">Are you sure you want to delete the CMS staff member?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button [mat-dialog-close]="false" mat-stroked-button color="dark" class="button-default">Cancel
            </button>
            <button mat-button [mat-dialog-close]="true" mat-flat-button color="error" class="button-default">Delete
            </button>
        </div>
    </div>
</ng-container>

<!-- update partial assignments -->
<ng-container *ngIf="(dialogType === 'update_partial_assignment') ">
    <div class="countable-dialog confirmation-dailog p-3">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Update Partial Reassign</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
            <p>
                We notice that you have reassigned staff for only partial engagements
            </p>
            <p class="text-error fw-semibold">Note: You will need to manually reassign the staff for any remaining
                engagements
                according to your requirements.</p>
            <p class="text-gray-6">Are you sure you want to update the staff members?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button [mat-dialog-close]="false" mat-stroked-button color="dark" class="button-default">Cancel
            </button>
            <button mat-button [mat-dialog-close]="true" mat-flat-button color="primary" class="button-default">Update
            </button>
        </div>
    </div>
</ng-container>

<!-- delete team member  -->
<ng-container *ngIf="(dialogType === 'not_cms_member') ">
    <div class="countable-dialog confirmation-dailog delete-user-dialog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center">
            <span class="badge badge-error badge-circle icon-bordered-error ">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <button mat-button class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-20 pt-2">
            <h4 class="title text-center">Delete User</h4>
            <p class="fw-medium">Are you sure you want to Delete the user as <br> this will impact the credit card
                billing
                from <br> next billing cycle?</p>
        </div>
        <div mat-dialog-actions class="dialog-footer flex-column" (click)="$event.stopPropagation()">
            <ng-container>
                <div class="button-group">
                    <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">
                        Cancel
                    </button>
                    <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true">
                        Delete
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<!-- flex engagements info -->
<ng-container *ngIf="(dialogType === 'flex_engagements_info') ">
    <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
        <div mat-dialog-title class="dialog-header  d-flex flex-column align-items-center">
            <span class="badge badge-error badge-circle icon-bordered-error ">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <button mat-button class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="content dialog-body-content text-center gap-20 mt-2 mb-32">
            <h4 class="title text-center">{{ dialogData.header }}</h4>
            <p class="fw-medium">{{ dialogData.subHeader }}</p>
            <p class="fw-medium text-error" *ngIf="dialogData?.count">{{ dialogData.count }}</p>
            <p class="fw-medium text-error" *ngIf="dialogData?.note">{{ dialogData.note }}</p>
        </div>
        <div mat-dialog-actions class="dialog-footer flex-column" (click)="$event.stopPropagation()">
            <ng-container>
                <div class="button-group">
                    <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">
                        Cancel
                    </button>
                    <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]="true">
                        Confirm
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-container
    *ngIf="(dialogType === 'upgrade_plan_creating_flex_free_trial' || dialogType === 'flex_added_not_activated')">
    <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
        <div class="dialog-header d-flex flex-column align-items-center">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-circle-exclamation"></i>
            </span>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <h4 class="title">{{ dialogHeader }}</h4>
            <p class="title"> {{ dialogData.subHeader }} </p>
            <p class="title"> {{ (aclModel && (aclModel.hasBilling || aclModel.isSuperAdmin)) ? dialogData.note :
                'Please contact your super admin for more information.' }}</p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group w-100" (click)="$event.stopPropagation()">
            @if ((aclModel && (aclModel.hasBilling || aclModel.isSuperAdmin))) {
            <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button color="primary" class="button-default" [mat-dialog-close]="true">Upgrade
            </button>
            } @else {
            <button mat-button mat-flat-button color="primary" class="button-default" [mat-dialog-close]="false">Ok
            </button>
            }

        </div>
    </div>
</ng-container>

<ng-container *ngIf="(dialogType === 'flex_account_policy')">
    <div class="countable-dialog w-400">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
            <h4 class="title text-center">Account Policy</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-16 mt-2 mb-32">
            <p class="align-items-start">
                You cannot deactivate {{ plan_addons_messages.FLEX_DISPLAY_NAME }} or delete/pause your account because
                there are active engagements with CMS staff.
            </p>
            <p class="text-gray-6">Here's what you can do:</p>
            <p class="d-flex align-items-start gap-8 text-start">
                <i class="fa-regular fa-circle-info text-error-darker"></i>
                Remove or reassign
                CMS staff from active engagements
            </p>
            <p class="d-flex align-items-start gap-8 text-start">
                <i class="fa-regular fa-circle-info text-error-darker"></i>
                Complete all active
                engagements with CMS staff
            </p>
            <p class="text-gray-6">Please contact support for further details
            </p>
        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]="false">OK
            </button>
            <button [mat-dialog-close]="true" mat-button mat-flat-button color="primary" class="button-default">Contact
                us
            </button>
        </div>
    </div>
</ng-container>